import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { StoreKPIsTable } from "../DropLocations/StoreKPIsTable";

const KpiScreen = () => {
  return (
    <main>
      <StoreKPIsTable />
    </main>
  );
};

export default withProtectedRoute(KpiScreen);
